<!-- If session expired -->

<div *ngIf="this.isSessionExpired" class="d-flex justify-content-center align-items-start" style="padding-top: 10vh;">
  <div class="card p-4 shadow rounded">
    <div class="d-flex align-items-center mb-3">
      <i class="pi pi-info-circle me-2 fs-2" style="color: #6c757d;"></i>
      <h5 class="mb-0">Your session has expired</h5>
    </div>
    <p>Your session expired due to prolonged inactivity. Please start a new session.</p>

    <hr class="session-expired-hr">

    <div class="d-flex justify-content-center">
      <button pButton type="button" label="Log In" class="btn btn-light" (click)="logout();"></button>
    </div>
  </div>
</div>

<!-- If session did not expiry -->
<div *ngIf="!this.isSessionExpired" class="d-flex justify-content-center align-items-start" style="min-height: 100vh; padding-top: 10vh;">
  Redirecting to the main page...
</div>